
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 800 800","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M100 466.667V333.333C100 314.924 114.924 300 133.333 300h88.308a33.336 33.336 0 0020.823-7.304l103.379-82.704C367.67 192.532 400 208.071 400 236.021V563.98c0 27.95-32.33 43.49-54.157 26.027l-103.379-82.704A33.347 33.347 0 00221.641 500h-88.308C114.924 500 100 485.077 100 466.667zM527.673 507.13a166.65 166.65 0 0038.87-100.733 166.675 166.675 0 00-31.026-103.418M629.813 592.836a299.997 299.997 0 002.67-382.445","stroke":"#fff","stroke-width":"66.667","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    